const namespace = 'basket';

export const ADD_ITEM = namespace + 'ADD_ITEM';
export const PLUS_ITEM_COUNT = namespace + 'PLUS_ITEM_COUNT';
export const MINUS_ITEM_COUNT = namespace + 'MINUS_ITEM_COUNT';
export const SET_ITEM_COUNT = namespace + 'SET_ITEM_COUNT'
export const RESET_BASKET = namespace + 'RESET_BASKET'
